import { FilterKey } from '@studyportals/search-filters';
import { FilterSelectionState } from '@/filters/selection/FilterSelectionState';
import { SeoHeadingHandlerDefaultSorting } from '../SeoHeadingHandlerDefaultSort';

export default class DisciplineAreas extends SeoHeadingHandlerDefaultSorting {
	protected async canHandleWithDefaultSorting(filterSelectionState: FilterSelectionState): Promise<boolean> {
		return (
			(await this.selectionOnlyFor([FilterKey.DISCIPLINES, FilterKey.AREA], filterSelectionState)) ||
			(await this.selectionOnlyFor([FilterKey.DISCIPLINES, FilterKey.AREA, FilterKey.COUNTRY], filterSelectionState))
		);
	}

	protected async selfHandle(filterSelectionState: FilterSelectionState): Promise<string> {
		const discipline = this.getFilterOptionNameBy(FilterKey.DISCIPLINES, filterSelectionState);

		const singleSelectionForArea = await this.singleSelectionFor(FilterKey.AREA, filterSelectionState);

		let location = 'selected areas';
		if (singleSelectionForArea) {
			const area = this.getFilterOptionNameBy(FilterKey.AREA, filterSelectionState);

			const countryName = this.getFilterOptionNameBy(FilterKey.COUNTRY, filterSelectionState);
			const country = countryName !== '' ? `, ${countryName}` : ``;

			location = `${area}${country}`;
		}

		const seoInfo = `List of universities to study ${discipline} in ${location}`;

		return Promise.resolve(seoInfo);
	}
}
